import { render, staticRenderFns } from "./SocialLinks.vue?vue&type=template&id=17bda37a&scoped=true"
import script from "./SocialLinks.vue?vue&type=script&lang=js"
export * from "./SocialLinks.vue?vue&type=script&lang=js"
import style0 from "./SocialLinks.vue?vue&type=style&index=0&id=17bda37a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bda37a",
  null
  
)

export default component.exports